import { GridLoader } from "react-spinners";

const LoadingView = () => {
  return (
    <div
      className="participant-table-container"
      style={{
        height: "100px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h3 style={{ color: "#123abc", marginBottom: "20px" }}>
        Applying changes
      </h3>
      <GridLoader color="#123abc" size={15} />
    </div>
  );
};

export default LoadingView;
